// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"e813a120","419":"6f07fead","439":"17675a28","458":"57ff7a6e","774":"d5da1b08","787":"c2323670","858":"32d4ef51","968":"3a18e5c4"}[chunkId] + ".chunk.js";
};